export default function getOr(defaultVal) {
  return function (keys) {
    return function (object) {
      var path = Array.isArray(keys) ? keys : keys.split('.');
      var obj = object ? object[path[0]] : undefined;
      if (obj && path.length > 1) {
        return getOr(defaultVal)(path.slice(1))(obj);
      }
      return obj === undefined ? defaultVal : obj;
    };
  };
}